import React, { useEffect, useState, useCallback } from "react";
import { connect } from "react-redux";
import * as XLSX from 'xlsx';
import {
  formatDate,
  formatNumberDate,
  formatDateTime,
} from "config/funciones/Comunes";
import {
  OK,
  TODOS_LOS_REGISTROS,
  PERFIL_PROMOTOR,
  LISTADO_PAGINACION_REPORTES_SUPERVISION,
  FILA_BLANCA,
  FILA_GRIS,
  CONFIGURACION_TIPOGRAFIA_14,
} from "config/general/Configuracion";
import { primaryColor, whiteColor} from "assets/jss/material-dashboard-pro-react.jsx";
import { listarUsuario } from "conten/usuarios/UsuarioActions";
import { informeSupervision } from "conten/informes/InformesActions";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer";
import WaitDialog from "conten/components/WaitDialog.jsx";
import TituloPagina2 from "conten/components/TituloPagina2";
import EncabezadoGrid from "conten/components/EncabezadoGrid";
import TablePagination from "components/TablePagination/TablePagination.jsx";
import CustomSelect from "components/CustomSelect/CustomSelect.jsx";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import { withStyles } from "@material-ui/core/styles";
import AssessmentIcon from "@material-ui/icons/Assessment";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";

const columnasOrdenar2 = [
  { campos: [{ id: "", isSorted: false, label: "Fecha Hora" }, { id: "", isSorted: false, label: "Zona" }], xs: 12, sm: 12, md: 2, lg: 2 },
  { campos: [{ id: "", isSorted: false, label: "Promotor" }], xs: 12, sm: 12, md: 3, lg: 3 },
  { campos: [{ id: "", isSorted: false, label: "Supervisor" }], xs: 12, sm: 12, md: 3, lg: 3 },
  { campos: [{ id: "", isSorted: false, label: "Firmado" }], xs: 12, sm: 12, md: 1, lg: 1 },
  { campos: [{ id: "", isSorted: false, label: "Información" }], xs: 12, sm: 12, md: 3, lg: 3 },
];

const columnasOrdenar3 = [
  { campos: [{ id: "", isSorted: false, label: "Cumple" }], xs: 12, sm: 12, md: 2, lg: 2 },
  { campos: [{ id: "", isSorted: false, label: "Pregunta" }], xs: 12, sm: 12, md: 7, lg: 7 },
  { campos: [{ id: "", isSorted: false, label: "Valor" }], xs: 12, sm: 12, md: 3, lg: 3 },
];

const InformeSupervision = ({ classes, usuarioState, informesState, listarUsuario, informeSupervision }) => {
  const fechaActual = formatDate(new Date(), "yyyy-mm-dd");
  const [datosConsulta, setDatosConsulta] = useState({
    fnInicio: formatNumberDate(fechaActual),
    fnFin: formatNumberDate(fechaActual),
    promotor: 0,
    paginacion: {
      limite: LISTADO_PAGINACION_REPORTES_SUPERVISION[0],
      traerTodo: false,
      actual: 1,
      filtro: null,
      orden: null,
      sentido: null,
    },
  });
  const [reporte, setReporte] = useState([]);

  useEffect(() => {
    listarUsuario({
      limite: TODOS_LOS_REGISTROS,
      actual: 1,
      filtro: PERFIL_PROMOTOR,
      orden: "nombre1, nombre2, apellido1, apellido2",
      sentido: "ASC",
    });
  }, []);

  useEffect(() => {
    recuperarReporte();
  }, [datosConsulta.fnInicio, datosConsulta.fnFin, datosConsulta.promotor]);

  const recuperarReporte = () => {
    informeSupervision(datosConsulta, (estado, contenido) => {
      if (estado === OK) {
        // Solo actualizar si el total cambió (opcional)
        setDatosConsulta(prev => ({
          ...prev,
          paginacion: {
            ...prev.paginacion,
            total: contenido.paginacion.total, // suponiendo que es lo único que cambia
          }
        }));

        const reporteProcesado = contenido.reporte.map((r) => ({
          ...r,
          valor: r.valor && r.valor !== "null" ? `, ${r.valor}` : '',
        }));
        setReporte(reporteProcesado);
      }
    });
  };

  const generarEstructuraImprimir = useCallback((data = reporte) => {
    const registros = {};
    const resultado = [];
    data.forEach((reg) => {
      const encabezado = {
        id: reg.id,
        fecha_hora: formatDateTime(new Date(reg.fecha_hora), "yyyy-mm-dd HH:MM"),
        supervisor_nombre: reg.supervisor_nombre,
        informacion: reg.informacion,
        es_firmado: reg.es_firmado ? 'SI' : 'NO',
        promotor_nombre: reg.promotor_nombre,
        zona: reg.zona,
        preguntas: [],
      };
      if (!registros[reg.id]) {
        registros[reg.id] = encabezado;
        resultado.push(encabezado);
      }
      registros[reg.id].preguntas.push({
        contenido: reg.contenido,
        valor: !reg.valor ? '' : reg.valor,
        cumple: reg.cumple ? 'SI' : 'NO',
      });
    });
    return resultado;
  }, [reporte]);

  const descargarTodoElReporte = () => {
    const consultaCompleta = {
      ...datosConsulta,
      paginacion: {
        ...datosConsulta.paginacion,
        traerTodo: true,
        actual: 1,
      }
    };

    informeSupervision(consultaCompleta, (estado, contenido) => {
      if (estado === OK) {
        const reporteCompleto = contenido.reporte.map((r) => ({
          ...r,
          valor: r.valor && r.valor !== "null" ? `, ${r.valor}` : '',
        }));

        const estructura = generarEstructuraImprimir(reporteCompleto);
        const contenidoExcel = estructura.map(reg => {
          const cont = {
            zona: reg.zona,
            fecha: reg.fecha_hora,
            promotor: reg.promotor_nombre,
            supervisor: reg.supervisor_nombre,
            observaciones: reg.informacion,
            "firma promotor": reg.es_firmado,
          };
          reg.preguntas.forEach(p => {
            cont[p.contenido] = `${p.cumple}\r\n${p.valor}`;
          });
          return cont;
        });

        const preguntas = Array.from(new Set(reporteCompleto.map(r => r.contenido)));
        const headers = [
          { title: "Zona", dataIndex: "zona" },
          { title: "Promotor", dataIndex: "promotor" },
          { title: "Fecha y hora", dataIndex: "fecha" },
          ...preguntas.map(p => ({ title: p, dataIndex: p })),
          { title: "Firma promotor", dataIndex: "firma promotor" },
          { title: "Supervisor", dataIndex: "supervisor" },
          { title: "Observaciones generales", dataIndex: "observaciones" },
        ];

        // Usar XLSX directamente para exportar
        const worksheet = XLSX.utils.json_to_sheet(contenidoExcel);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte supervisión");
        XLSX.writeFile(workbook, "Reporte_Supervision_Completo.xlsx");
      }
    });
  };


  const getNombresReferenicasXLS = () => {
    const preguntas = Array.from(new Set(reporte.map(r => r.contenido)));
    return [
      { title: "Zona", dataIndex: "zona" },
      { title: "Promotor", dataIndex: "promotor" },
      { title: "Fecha y hora", dataIndex: "fecha" },
      ...preguntas.map(p => ({ title: p, dataIndex: p })),
      { title: "Firma promotor", dataIndex: "firma promotor" },
      { title: "Supervisor", dataIndex: "supervisor" },
      { title: "Observaciones generales", dataIndex: "observaciones" },
    ];
  };

  const getContenidosXLS = () => {
    const contenido = generarEstructuraImprimir();
    return contenido.map(reg => {
      const cont = {
        zona: reg.zona,
        fecha: reg.fecha_hora,
        promotor: reg.promotor_nombre,
        supervisor: reg.supervisor_nombre,
        observaciones: reg.informacion,
        "firma promotor": reg.es_firmado,
      };
      reg.preguntas.forEach(p => {
        cont[p.contenido] = `${p.cumple}\r\n${p.valor}`;
      });
      return cont;
    });
  };

  const renderFila = (preguntas) => preguntas.map((contenido, index) => {
    const colorFila = index % 2 === 0 ? FILA_BLANCA : FILA_GRIS;
    return (
      <React.Fragment key={index}>
        <GridItem xs={12} sm={12} md={2} lg={2} style={{ backgroundColor: colorFila }}>{contenido.cumple}</GridItem>
        <GridItem xs={12} sm={12} md={7} lg={7} style={{ backgroundColor: colorFila }}>{contenido.contenido}</GridItem>
        <GridItem xs={12} sm={12} md={3} lg={3} style={{ backgroundColor: colorFila }}>{contenido.valor || "--"}</GridItem>
      </React.Fragment>
    );
  });

  const cambioPagina = (page) => {
    setDatosConsulta(prev => ({
      ...prev,
      paginacion: { ...prev.paginacion, actual: page },
    }));
    recuperarReporte();
  };

  const cambioLimite = (numFilas) => {
    setDatosConsulta(prev => ({
      ...prev,
      paginacion: { ...prev.paginacion, limite: numFilas, actual: 1 },
    }));
    recuperarReporte();
  };

  const handleFechaInicio = (e) => {
    setDatosConsulta(prev => ({ ...prev, fnInicio: formatNumberDate(e.target.value) }));
  };

  const handleFechaFin = (e) => {
    setDatosConsulta(prev => ({ ...prev, fnFin: formatNumberDate(e.target.value) }));
  };

  const handlePromotorChange = (e) => {
    setDatosConsulta(prev => ({ ...prev, promotor: e.target.value }));
  };

  const promotores = usuarioState.usuarios.filter(p => p.c_activo && p.perfil + "" === PERFIL_PROMOTOR);

  const reporteImprimir = generarEstructuraImprimir();
  const paginacion = datosConsulta.paginacion;

  return (
    <GridItem xs={12}>
      {informesState.isActivityIndicatorShown && <WaitDialog text="Un momento mientras completamos su solicitud." />}
      <Card>
        <CardHeader icon>
          <CardIcon color="primary">
            <button
              style={{ cursor: "pointer", backgroundColor: primaryColor[0], color: whiteColor, border: 0 }}
              onClick={descargarTodoElReporte}
            >
              <b>+ Descargar todo</b>
            </button>

            <AssessmentIcon />
          </CardIcon>
          <TituloPagina2 texto="Informe de supervisión" color="primary" classes={classes} />
        </CardHeader>
        <CardBody>
          <GridContainer spacing={2}>
            <GridItem xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <TextField
                  label="Fecha Inicio"
                  type="date"
                  defaultValue={fechaActual}
                  onChange={handleFechaInicio}
                  InputLabelProps={{ shrink: true }}
                />
              </FormControl>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <TextField
                  label="Fecha Fin"
                  type="date"
                  defaultValue={fechaActual}
                  onChange={handleFechaFin}
                  InputLabelProps={{ shrink: true }}
                />
              </FormControl>
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <CustomSelect
                labelText="* Promotor"
                id="promotor"
                formControlProps={{ fullWidth: true }}
                inputProps={{ name: "promotor", value: datosConsulta.promotor, onChange: handlePromotorChange }}
                selectContent={[
                  <MenuItem key="promotorTodos" value={0}>Todos los promotores</MenuItem>,
                  ...promotores.map(p => (
                    <MenuItem key={p.c_id} value={p.c_id}>{`${p.nombre1} ${p.nombre2} ${p.apellido1} ${p.apellido2} (${p.identificacion})`}</MenuItem>
                  ))
                ]}
              />
            </GridItem>
          </GridContainer>

          {reporteImprimir.map((registro, index) => (
            <GridContainer key={index} container alignItems="center" style={{ ...CONFIGURACION_TIPOGRAFIA_14, backgroundColor: FILA_BLANCA }}>
              <GridItem xs={12}><EncabezadoGrid contenidoColumnas={columnasOrdenar2} /></GridItem>
              <GridItem xs={12} sm={12} md={2} lg={2}><div>{registro.fecha_hora}</div><div>{registro.zona}</div></GridItem>
              <GridItem xs={12} sm={12} md={3} lg={3}>{registro.promotor_nombre}</GridItem>
              <GridItem xs={12} sm={12} md={3} lg={3}>{registro.supervisor_nombre}</GridItem>
              <GridItem xs={12} sm={12} md={1} lg={1}>{registro.es_firmado}</GridItem>
              <GridItem xs={12} sm={12} md={3} lg={3}>{registro.informacion}</GridItem>
              <GridItem xs={12}><EncabezadoGrid contenidoColumnas={columnasOrdenar3} /></GridItem>
              {renderFila(registro.preguntas)}
            </GridContainer>
          ))}

          {paginacion && (
            <TablePagination
              color="success"
              rowsPerPageOptions={LISTADO_PAGINACION_REPORTES_SUPERVISION}
              pages={Math.ceil(paginacion.total / paginacion.limite)}
              rowsPerPage={paginacion.limite}
              page={paginacion.actual}
              onChangePage={cambioPagina}
              onChangeRowsPerPage={cambioLimite}
            />
          )}
        </CardBody>
      </Card>
    </GridItem>
  );
};

const mapStateToProps = (state) => ({
  usuarioState: state.usuarioState,
  informesState: state.informesState,
});

const mapDispatchToProps = (dispatch) => ({
  listarUsuario: (paginacion) => dispatch(listarUsuario(paginacion, () => { })),
  informeSupervision: (params, callback) => dispatch(informeSupervision(params, callback)),
});

export default withStyles(extendedTablesStyle)(connect(mapStateToProps, mapDispatchToProps)(InformeSupervision));

